import { EditIcon, Loading, TrashIcon } from 'components'
import { Box, Flex } from 'theme-ui'
import { useSingleLocation } from 'hooks/locationHooks/useSingleLocation'
import { ViewMode } from 'types'
import { ErrorMessage } from 'components/Form'
import { getCountryByCode } from 'components/Form/countryCodes'
import { getFromLocalizedString } from 'utils/getFromLocalizedString'

export type LocationCardProps = {
  locationId: string
  viewMode?: ViewMode
  onEditLocation?: (locationId: string) => void
  onRemoveLocation?: (locationId: string) => void
}

export const LocationCard = ({
  locationId,
  viewMode = 'view',
  onEditLocation,
  onRemoveLocation,
}: LocationCardProps) => {
  const [location, loading, error] = useSingleLocation(locationId)
  const {
    name = '',
    addressLine = '',
    zip = '',
    city = '',
    state = '',
    countryCode = '',
    specialInstructions = '',
  } = location ?? {}
  const country = getCountryByCode(countryCode)?.label ?? ''

  return (
    <Box className="LocationCard">
      {loading || (!error && !location?.name) ? (
        <Loading />
      ) : error ? (
        <ErrorMessage>
          <span>{error}</span>
        </ErrorMessage>
      ) : (
        <Box sx={{ fontSize: 2, lineHeight: '22px' }}>
          <Box>{getFromLocalizedString(name)}</Box>
          <Box>{addressLine}</Box>
          <Box>
            {city}
            {state && ', '}
            {state}
          </Box>
          <Box>
            {country}
            {zip && ' - '}
            {zip}
          </Box>
          {specialInstructions && (
            <Box variant="text.informational" sx={{ pt: '5px' }}>
              Special Instructions:{' '}
              {getFromLocalizedString(specialInstructions)}
            </Box>
          )}
          {viewMode === 'edit' && (
            <Flex sx={{ width: 250, justifyContent: 'space-between', pt: 17 }}>
              {onEditLocation && (
                <Box
                  data-cy="edit-location"
                  onClick={() => onEditLocation(locationId)}
                  sx={{
                    color: 'textPrimary',
                    cursor: 'pointer',
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <EditIcon
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      pr: '5px',
                    }}
                  />
                  Edit
                </Box>
              )}
              {onRemoveLocation && (
                <Box
                  data-cy="remove-location"
                  onClick={() => onRemoveLocation(locationId)}
                  sx={{
                    color: 'textPrimary',
                    cursor: 'pointer',
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <TrashIcon
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      pr: '5px',
                    }}
                  />{' '}
                  Remove
                </Box>
              )}
            </Flex>
          )}
        </Box>
      )}
    </Box>
  )
}
